import { ENUM_FORM_LAYOUT_CONTAINER } from "../components/pageList";
import { IconSettings } from "@tabler/icons";
import ClientDueDiligenceCountry from "../components/clientDueDiligenceCountry";
import ClientDueDiligenceRelatedParty from "../components/clientDueDiligenceRelatedParty";
import ClientDueDiligenceNameScreening from "../components/clientDueDiligenceNameScreening";
import { resolveClientDueDiligenceCountries } from "./clientDueDiligenceValues";

export {
  assignDueDiligenceCountry,
  dueDiligenceCountryValue,
  resolveClientDueDiligenceChecks,
  resolveClientDueDiligenceCountries,
  resolveClientDueDiligenceCountry,
} from "./clientDueDiligenceValues";

const isCountryMissing = (value) =>
  value == null || String(value).trim() === "";

export const withClientDueDiligence = (schema, { t, required = false } = {}) => {
  if (!schema?.layout) return schema;

  const translate = t || ((value) => value);
  const containers = schema.layout.containers.map((container) => {
    if (container.key !== "t1" || !Array.isArray(container.steps)) {
      return container;
    }
    if (container.steps.some((step) => step.key === "t1-dd")) return container;

    const confirmIndex = container.steps.findIndex((step) => step.key === "t1-5");
    const step = {
      key: "t1-dd",
      label: "Client Due Diligence",
      icon: IconSettings,
    };
    const steps = [...container.steps];
    if (confirmIndex >= 0) steps.splice(confirmIndex, 0, step);
    else steps.push(step);
    return { ...container, steps };
  });

  const hasSection = containers.some(
    (container) => container.key === "section-due-diligence"
  );

  return {
    ...schema,
    initialValues: {
      ...(schema.initialValues || {}),
      dueDiligence: {
        country: "",
        ...(schema.initialValues?.dueDiligence || {}),
      },
    },
    validate: {
      ...(schema.validate || {}),
      ...(required
        ? {
            "dueDiligence.country": (value, formValues) =>
              isCountryMissing(value) &&
              resolveClientDueDiligenceCountries(formValues).length === 0
                ? translate("Country is required")
                : null,
          }
        : {}),
    },
    layout: {
      ...schema.layout,
      containers: hasSection
        ? containers
        : [
            ...containers,
            {
              key: "section-due-diligence",
              parent: "t1-dd",
              type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
              props: {
                title: "Client Due Diligence",
                titleOrder: 5,
                description:
                  "Screen each country already entered, and whether the client matches a related party.",
                withBorder: false,
                withPaper: false,
                ml: 10,
                mt: 0,
                mb: 10,
              },
            },
          ],
      fields: [
        ...schema.layout.fields,
        {
          name: "dueDiligence.country",
          component: ClientDueDiligenceCountry,
          parent: "section-due-diligence",
          props: {
            label: "Country",
            required,
          },
          fieldSpacing: "lg",
        },
        {
          name: "dueDiligence.relatedParty",
          component: ClientDueDiligenceRelatedParty,
          parent: "section-due-diligence",
          props: {},
        },
        {
          name: "dueDiligence.nameScreening",
          component: ClientDueDiligenceNameScreening,
          parent: "section-due-diligence",
          props: {},
        },
      ],
    },
  };
};
